import { apiClient } from '@/api/client';
import type { PaginatedResult } from '@/types/api';
import type {
  SecurityAlert, SecurityAlertDetail, AlertStats, AlertListParams, AlertBulkAction,
} from '@/features/alerts/types';

/** Security Alert Center — NEW mail-admin-service /alerts endpoints (Sprint 4.4). */
export const alertsApi = {
  list: async (params: AlertListParams): Promise<PaginatedResult<SecurityAlert>> =>
    (await apiClient.get<PaginatedResult<SecurityAlert>>('/alerts', { params })).data,
  stats: async (): Promise<AlertStats> => (await apiClient.get<AlertStats>('/alerts/stats')).data,
  detail: async (id: string): Promise<SecurityAlertDetail> => (await apiClient.get<SecurityAlertDetail>(`/alerts/${id}`)).data,
  acknowledge: async (id: string): Promise<void> => { await apiClient.post(`/alerts/${id}/acknowledge`, {}); },
  resolve: async (id: string): Promise<void> => { await apiClient.post(`/alerts/${id}/resolve`, {}); },
  escalate: async (id: string): Promise<void> => { await apiClient.post(`/alerts/${id}/escalate`, {}); },
  assign: async (id: string, assigneeId: string): Promise<void> => { await apiClient.post(`/alerts/${id}/assign`, { assigneeId }); },
  addNote: async (id: string, note: string): Promise<void> => { await apiClient.post(`/alerts/${id}/notes`, { note }); },
  bulk: async (action: AlertBulkAction, ids: string[]): Promise<{ affected: number; failed: number }> =>
    (await apiClient.post<{ affected: number; failed: number }>('/alerts/actions', { action, ids })).data,
};
